<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import DecoratedHeadline from "../components/DecoratedHeadline.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import Reference from "../components/References/Reference.svelte";
	import Button from "../components/Button.svelte";
	import ProductCard from "../components/ProductCard.svelte";
	import BlogPostCard from "../components/BlogPostCard.svelte";
	import ProductsFilter from "../components/ProductsFilter.svelte";
	import Contact from "../components/Contact.svelte";
	import HelpSection from "../components/HelpSection.svelte";
	import type { PublishedCaseStudy } from "../../../core/schema/CaseStudy.js";
	import type { Product } from "../../../core/schema/Product.js";
	import type { Category } from "../../../core/schema/Category.js";
	import type { PublishedBlogPost } from "../../../core/schema/BlogPost.js";
	import { productsAnchorPathMap } from "../../../core/schema/paths/productsAnchorPathMap";
	import { getGlobalSettings } from "../getGlobalSettings";

	export let references: PublishedCaseStudy[];
	export let products: Product[];
	export let categories: Category[];
	export let blogPosts: PublishedBlogPost[];

	export let heading: string;
	export let perex: string;

	const { TENANT_LOCALE } = getGlobalSettings();

	let selectedCategory = "";

	let visibleReferences = 2;
	let visibleBlogPosts = 3;
</script>

<Layout>
	<div class="mt-20 flex flex-col items-center gap-8 px-4 md:px-8">
		<DecoratedHeadline h1 class="mb-8">{nbspify(heading)}</DecoratedHeadline>
		<p class="max-w-[70.625rem] text-center text-lg font-bold text-gray-400 md:text-[2rem] lg:text-[3rem]">
			<slot name="subHeading" />
		</p>
		<p class="text-bito-black max-w-[50.25rem] text-center">
			{nbspify(perex)}
		</p>
	</div>

	<div class="mt-24 flex flex-col gap-16">
		<DecoratedHeadline>{nbspify("Z referencí")}</DecoratedHeadline>
		<div class="flex flex-wrap justify-center gap-5 gap-x-5 gap-y-16 px-4">
			{#each references.slice(0, visibleReferences) as reference}
				<Reference {reference} />
			{/each}
		</div>
		{#if visibleReferences < references.length}
			<div class="flex w-full justify-center px-4">
				<Button
					variant="secondary"
					class="mt-10 w-full max-w-[27.5rem]"
					on:click={() => {
						visibleReferences += 2;
					}}
				>
					{nbspify("Načíst další reference")}
				</Button>
			</div>
		{/if}
	</div>

	<div class="mt-24 flex flex-col gap-16">
		<DecoratedHeadline>{nbspify("Z produktů")}</DecoratedHeadline>
		<div class="flex flex-col items-center justify-center gap-4 md:flex-row">
			<p class="text-primary text-xs font-extrabold">{nbspify("Filtr kategorie produktů")}</p>
			<div class="flex max-w-[52.25rem] flex-wrap justify-center gap-1 gap-y-2">
				<ProductsFilter
					category={undefined}
					customHref={productsAnchorPathMap[TENANT_LOCALE]}
					productCount={products.length}
					bind:selected={selectedCategory}
				/>
				{#each categories.filter((item) => item.parentId === undefined) as category}
					<ProductsFilter
						customHref={productsAnchorPathMap[TENANT_LOCALE]}
						{category}
						productCount={products.filter((item) => item.categoryId === category.id).length}
						bind:selected={selectedCategory}
					/>
				{/each}
			</div>
		</div>
		<div id="produkty" class="mx-auto flex max-w-[100rem] flex-wrap justify-center gap-5 gap-x-5 gap-y-16 sm:px-4">
			{#each products.filter((item) => selectedCategory === item.categoryId || selectedCategory === "") as product}
				{@const category = categories.find((item) => product.categoryId === item.id)}
				{#if category}
					<ProductCard {product} {category} />
				{/if}
			{/each}
		</div>
	</div>

	<div class="mt-24 flex flex-col gap-16">
		<DecoratedHeadline>{nbspify("Z blogu")}</DecoratedHeadline>
		<div class="flex flex-wrap justify-center gap-5 gap-x-5 gap-y-16 px-4">
			{#each blogPosts.slice(0, visibleBlogPosts) as blogPost}
				<BlogPostCard {blogPost} />
			{/each}
		</div>
		{#if visibleBlogPosts < blogPosts.length}
			<div class="flex w-full justify-center px-4">
				<Button
					variant="secondary"
					class="mt-10 w-full max-w-[27.5rem]"
					on:click={() => {
						visibleBlogPosts += 3;
					}}
				>
					{nbspify("Načíst další články")}
				</Button>
			</div>
		{/if}
	</div>

	<div class="mx-auto mt-64 flex max-w-[120rem] flex-col items-center gap-64 px-4 md:px-8">
		<p class="max-w-[70.625rem] text-center text-lg font-bold text-gray-400 md:text-[2rem] lg:text-[3rem]">
			{nbspify(
				"Potřebujete sofistikovanější radu? Vyplňte formulář a naši odborníci si s vámi domluví schůzku, kde všechno proberete!",
			)}
		</p>
		<Contact showText={false} />
		<HelpSection />
	</div>
</Layout>
